import { ReactNode } from 'react';
import { OnlineThemeType } from '../../themes/online';
import styled, { css } from 'styled-components';
import { IProfileProps, IProfilePropsWithTheme } from './Profile';
import React from 'react';

export interface AppBarActionsProps {
  className?: string;
  children?: ReactNode;
}

export interface AppBarActionsPropsWithTheme extends AppBarActionsProps {
  theme: OnlineThemeType;
}

const StyledAppBarActions = ({ theme }: IProfilePropsWithTheme) => {
  return css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 16px;
    position: relative;
  `;
};

export const AppBarActions = styled((props: AppBarActionsProps) => {
  return <div className={props.className}>{props.children}</div>;
})`
  ${StyledAppBarActions}
` as React.FC<AppBarActionsProps>;
